// extracted by mini-css-extract-plugin
module.exports = {"margin-b-16":"_2VfrfeKXfX","margin-l-16":"_3RE2rwaXAy"};